var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMokaiHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1078.27 324.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-3 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-5 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-6 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-7 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-8 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-9 {\n        fill: url(#linear-gradient-8);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 297.94,
    y1: 539.16,
    x2: 297.94,
    y2: 6.82,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#057fc1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#0b7cbf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#1e74b9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3c67af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6555a1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#9b3e8f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#db227a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e61d76"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 188.83,
    y1: 539.16,
    x2: 188.83,
    y2: 6.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 79.73,
    y1: 539.16,
    x2: 79.73,
    y2: 6.82,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 93.26,
    y1: 57.84,
    x2: 93.26,
    y2: -5.96,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 510.13,
    y1: 255.06,
    x2: 510.13,
    y2: 365.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 681.66,
    y1: 255.06,
    x2: 681.66,
    y2: 365.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 837.04,
    y1: 255.06,
    x2: 837.04,
    y2: 365.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: 974.06,
    y1: 255.06,
    x2: 974.06,
    y2: 365.27,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 1070.11,
    y1: 255.06,
    x2: 1070.11,
    y2: 365.27,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "m377.67,188.83c0,50.55-19.86,96.46-52.21,130.36-4.56,4.78-11.57,6.34-17.73,3.96-71.65-27.66-89.83-50.15-89.52-67.28.53-29.03,54.07-37.84,78.19-89.19,12.95-27.57,12.75-58.14,5.92-88.22-3.75-16.5,16.89-27.27,28.09-14.59,29.41,33.29,47.26,77.04,47.26,124.96Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m275.91,40.63l-72.94,126.33c-6.29,10.89-22,10.89-28.29,0L101.75,40.63c-4.77-8.26-1.49-18.89,7.15-22.93C133.18,6.34,160.26,0,188.83,0c28.57,0,55.66,6.34,79.93,17.7,8.64,4.04,11.92,14.67,7.15,22.93Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m69.94,323.16c-6.17,2.38-13.17.82-17.73-3.96C19.86,285.29,0,239.39,0,188.83c0-47.91,17.84-91.66,47.25-124.95,11.2-12.68,31.84-1.91,28.09,14.59-6.83,30.08-7.03,60.64,5.92,88.21,24.12,51.35,77.66,60.16,78.19,89.19.31,17.13-17.87,39.62-89.52,67.28Z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-8",
    x1: 93.26,
    y1: 25.94,
    x2: 93.26,
    y2: 25.94
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m563.34,135.01l-44.88,89.25c-1.7,3.23-4.93,4.76-8.33,4.76s-6.63-1.53-8.16-4.76l-44.88-89.25-19.38,88.57c-.85,3.74-3.74,5.27-6.63,5.27-3.91,0-7.65-2.55-7.65-6.97,0-.51,0-1.02.17-1.53l23.29-105.74c.85-3.91,4.08-5.95,7.14-5.95s6.12,2.21,7.99,5.78l48.11,95.37,48.11-95.37c1.87-3.57,4.93-5.95,7.99-5.95,3.23,0,6.29,2.04,7.14,6.12l23.29,105.57c0,.68.17,1.19.17,1.7,0,4.42-3.74,6.97-7.65,6.97-2.89,0-5.78-1.53-6.46-5.27l-19.38-88.57Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m681.49,229.02c-41.48,0-69.53-25.67-69.53-61.03s28.05-60.86,69.53-60.86,69.87,25.67,69.87,60.86-28.39,61.03-69.87,61.03Zm0-109.48c-30.6,0-52.53,19.72-52.53,48.45s21.93,48.45,52.53,48.45,52.7-19.55,52.7-48.45-22.1-48.45-52.7-48.45Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "m792.84,171.56l83.98-61.37c1.53-1.02,3.06-1.7,4.76-1.7,3.4,0,6.46,2.72,6.46,6.63,0,2.38-1.36,4.08-3.91,5.95l-51.68,37.91,62.39,56.27c1.7,1.53,2.72,3.4,2.72,5.61,0,4.42-3.91,8.16-7.82,8.16-1.87,0-3.57-.85-5.27-2.21l-64.77-58.48-26.86,19.72v32.81c0,5.27-4.25,8.16-8.33,8.16s-7.99-2.89-7.99-8.16v-104.55c0-4.93,4.08-7.82,8.16-7.82s8.16,2.89,8.16,7.82v55.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "m1015.54,198.93h-83.13l-15.64,26.69c-1.36,2.38-3.91,3.4-6.12,3.4-3.91,0-7.65-3.06-7.65-7.48,0-1.36.34-2.55,1.02-3.74l62.22-105.57c1.7-2.72,4.08-4.25,7.82-4.25s6.12,1.53,7.82,4.25l62.22,105.57c.68,1.19,1.02,2.38,1.02,3.74,0,4.42-3.91,7.48-7.65,7.48-2.38,0-4.76-1.02-6.12-3.4l-15.81-26.69Zm-41.48-70.55l-34.51,58.48h68.85l-34.34-58.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m1061.95,116.31c0-4.93,3.91-7.82,8.16-7.82s8.16,2.89,8.16,7.82v104.55c0,5.27-3.74,8.16-8.33,8.16-4.08,0-7.99-2.89-7.99-8.16v-104.55Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMokaiHorizontal);
export default __webpack_public_path__ + "static/media/mokai-horizontal.85f1daf9048df81012a86db85a92029e.svg";
export { ForwardRef as ReactComponent };